import { ERozsahPPN } from 'services/dokumenty/navyseni';

export const rozsahPpnSelect = [
    {
        value: ERozsahPPN.VSECHNY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_VYBRANECP_ANO_VSECHNY'
    },
    {
        value: ERozsahPPN.VYBRANE,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_VYBRANECP_ANO_VYBRANE'
    }
];
